import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IFilterComp, IFilterParams } from 'ag-grid-community';

@Component({
  selector: 'app-custom-type-select',
  template: `<div class="container-div">
    <span class="menu-item" [ngClass]="{ 'selected': selectedType === 'System.String' }" (click)="applyFilter('System.String')">String</span>
    <span class="menu-item" [ngClass]="{ 'selected': selectedType === 'System.Number' }" (click)="applyFilter('System.Number')">Number</span>
    <span class="menu-item" [ngClass]="{ 'selected': selectedType === 'System.DateTime' }" (click)="applyFilter('System.DateTime')">Date</span>

  </div>`,
  styles: [`.container-div {
    width:auto;
    display:flex;
    gap:10px;
    flex-direction:column;
  }
  .menu-item{
    cursor:pointer;
    padding:10px;
  }
  .selected{
    background-color: #61C478 !important;;
  }
  `]
})
export class CustomTypeSelectComponent implements IFilterComp {

  params!: any;
  filterValue: string = "";
  guiElement: HTMLElement | null = null;

  selectedType: string = 'System.String'



  applyFilter(type: string) {
    if (this.params.context && this.params.context.componentParent) {
      console.log('params', this.params.column.colId)
      this.params.context.componentParent.applyMenuSelection({ colId: this.params.column.colId, type: type });
    }
    this.setType(type);
  }

  setType(type?: string) {
    if (this.params.context && this.params.context.componentParent) {
      if (type) {
        this.selectedType = type
      } else {
        this.selectedType = this.params.context.componentParent?._columnTypes?.find(x => x.fieldName == this.params.column.colId)?.fieldType || 'System.String'
      }
    }
  }

  agInit(params: IFilterParams): void {

    this.params = params;
    console.log('params', params)

    this.setType()

  }

  onFilterChange() {
    this.params.filterChangedCallback();
  }

  doesFilterPass(params: any): boolean {
    const fieldValue = params.data[this.params.colDef.field];
    // Null kontrolleri ekle
    if (fieldValue === null || fieldValue === undefined) {
      return this.filterValue === "";
    }
    return fieldValue
      .toString()
      .toLowerCase()
      .includes(this.filterValue.toLowerCase());
  }

  isFilterActive(): boolean {
    return this.filterValue !== "";
  }

  getModel() {
    return this.isFilterActive() ? { value: this.filterValue } : null;
  }

  setModel(model: any) {
    this.filterValue = model?.value || "";
  }

  getGui(): HTMLElement {
    // Bu method çağrıldığında DOM elementi döndür
    if (!this.guiElement) {
      this.guiElement = document.createElement("div");
    }
    return this.guiElement;
  }



  // Filtre temizleme metodu
  resetFilter() {
    this.filterValue = "";
    this.onFilterChange();
  }

  // Bileşen yok edildiğinde
  destroy() {
    // Temizlik işlemleri gerekirse
    this.guiElement = null;
  }


}
